export default __webpack_public_path__ + "static/2019-largest-music-festivals-where-to-go-and-how-to-book-lollapalooza-0628daa471806d05395475f74380396f.jpg";